<div class="flex flex-middle w-9 w-11-s"
  [ngClass]="dotColourClass">
  <p class="p2"> {{label | translate}}
  </p>
</div>
@if (isRange && storePhoneNumber) {
  <p class="p1 col-11 m-t-1"
    >{{'For more information
    call' |
    translate }}: <a [attr.href]="'tel:' + storePhoneNumber">{{storePhoneNumber}}</a></p>
  }